module.exports = "/_next/static/images/yatoo-vertical.vn-8521b98c3001913e46f1d517c4d78eff.svg";